import { type OnrApiMutationOptions, useOnrApi } from './mutation/useOnrApi.ts'

export interface UpdateWaitTimeTypeApiVariables {
  regionId: string
  value: 'default' | 'increased'
}

export const useUpdateWaitTimeType = (options?: OnrApiMutationOptions<void, UpdateWaitTimeTypeApiVariables>) =>
  useOnrApi<void, UpdateWaitTimeTypeApiVariables>({ type: 'updateWaitTimeType', ...options })
